const firebaseConfig = {
    apiKey: "AIzaSyBLkOMxFQi3A47uzRNYb6SHjQJfp3oQRZc",
    authDomain: "booking-burj-al-arab.firebaseapp.com",
    projectId: "booking-burj-al-arab",
    storageBucket: "booking-burj-al-arab.appspot.com",
    messagingSenderId: "124342945852",
    appId: "1:124342945852:web:76f42aa1d61229dc159b39"
};

export default firebaseConfig;